import { Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ApiPagedResponse } from 'app/client-core/api-response-models';

@Component({
  selector: 'app-expandable-table',
  templateUrl: './expandable-table.component.html',
  styleUrls: ['./expandable-table.component.scss']
})
export class ExpandableTableComponent implements OnInit {
  @Input() itemsData: any[];
  @Input() columns: any[];
  @Input() page: number;
  @Input() pageSize: number = 5;
  @Input() totalItems: number;
  @Output() pageChange = new EventEmitter();
  @ContentChild('detailsTemplate') detailsTemplate: TemplateRef<ElementRef>;
  
  constructor() { }

  ngOnInit() {
    console.log(this.columns)
  }

  onPageChange(event) {
    this.pageChange.emit(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/expandable-table/expandable-table.component.ts